<template>
  <section class="form-request">
    <div class="form-request__wrapper">
      <form
        ref="form_request"
        @submit.prevent="submit"
      >
          <!-- requestDate -->
        <div class="form-request__date">
          <BaseCaption :text="form.captions[0].text" tag="h3" />
          <div class="form-request__date-items">
            <div class="form-request__date-item">

              <BaseLabel
              :required="form.fields[0].required"
              :text="form.fields[0].label">
              </BaseLabel>
              <no-ssr>
                <div class="data-picker">
                  <test
                    :language="language"
                    format="yyyy-MM-dd"
                    v-model="formData.date"
                  />
                  <div class="data-picker__svg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <defs/>
                      <path d="M462 44h-47.667V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14h-168V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14.37c-.85-.235-1.741-.37-2.666-.37H83.823c-27.57 0-50 22.43-50 50v170.333c0 5.523 4.478 10 10 10s10-4.477 10-10V147h360.51c5.522 0 10-4.477 10-10s-4.478-10-10-10H53.823V94c0-16.542 13.458-30 30-30h39.844c.925 0 1.816-.136 2.666-.37V76.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64h168v12.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64H462c16.542 0 30 13.458 30 30v379.994c0 9.928-8.077 18.006-18.006 18.006s-18.006-8.078-18.006-18.006v-25.869c0-5.523-4.478-10-10-10H329.667c-5.522 0-10 4.477-10 10s4.478 10 10 10h106.321v15.869c0 6.511 1.648 12.643 4.545 18.006H38c-9.925 0-18-8.075-18-18v-15.875h223.825c5.522 0 10-4.477 10-10s-4.478-10-10-10h-99.916c17.474-15.049 28.57-37.309 28.57-62.125 0-45.215-36.785-82-82-82s-82 36.785-82 82c0 24.816 11.096 47.076 28.57 62.125H10c-5.522 0-10 4.477-10 10V474c0 20.953 17.047 38 38 38h435.994C494.95 512 512 494.951 512 473.994V94c0-27.57-22.43-50-50-50zM166.333 76.5c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zm228 0c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zM28.479 376c0-34.187 27.813-62 62-62s62 27.813 62 62-27.813 62-62 62-62-27.813-62-62z"/>
                      <path d="M468.309 129.93c-1.859-1.86-4.439-2.93-7.069-2.93-2.631 0-5.21 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07c1.861 1.86 4.439 2.93 7.07 2.93 2.63 0 5.21-1.07 7.069-2.93 1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07zM298.649 441.05c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21 1.06-7.07 2.92c-1.86 1.87-2.93 4.44-2.93 7.07 0 2.64 1.069 5.21 2.93 7.08 1.86 1.86 4.44 2.92 7.07 2.92s5.21-1.06 7.069-2.92c1.86-1.87 2.931-4.45 2.931-7.08s-1.07-5.2-2.931-7.07zM226.245 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM132.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM226.245 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM126.104 351.629c-3.906-3.905-10.236-3.905-14.143 0l-32.566 32.567-11.129-11.129c-3.906-3.905-10.236-3.905-14.143 0-3.905 3.905-3.905 10.237 0 14.143l18.201 18.199c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l39.638-39.638c3.905-3.905 3.905-10.237 0-14.142z"/>
                    </svg>
                  </div>
                </div>
              </no-ssr>
                <BaseErrorMessage v-if="errors.date">
                  {{ errors.date }}
                </BaseErrorMessage>
            </div>

            <div class="form-request__date-item">
              <BaseLabel
              :required="form.fields[1].required"
              :text="form.fields[1].label">
                <BaseInput
                v-model="formData.label"
                :name="form.fields[1].name"
                :type="form.fields[1].type" />
              </BaseLabel>
              <BaseErrorMessage v-if="errors.label">
                  {{ errors.label }}
                </BaseErrorMessage>
            </div>
          </div>
        </div>

        <!-- requestConcept -->
          <div class="form-request__concept">
            <!-- <BaseCaption :text="form.captions[1].text" tag="h3" /> -->
            <BaseLabel
              :required="form.fields[2].required"
              :text="form.fields[2].label"/>
            <div class="form-request__concept-item">
                <textarea
                v-model="formData.description"
                name="description"></textarea>
                <BaseErrorMessage v-if="errors.description">
                  {{ errors.description }}
                </BaseErrorMessage>
            </div>
          </div>

        <BaseCaption :text="form.captions[8].text" tag="h3" />

        <div
          v-for="item in form.work_type.items"
          :key="item.value"
          class="form-request__person-work_type"
        >
          <BaseRadioSingle
            :item="item"
            :value="formData.work_type"
            @update:value="handleWorkTypeChange($event)"
          />

          <div
            class="form-request__person-external-images"
            v-if="formData.work_type === item.value"
          >
            <BaseCaption
              :text="form.captions[formData.work_type === 'handmade' ? 9 : 10].text"
              tag="h6" />
            <BaseRadio
              :value.sync="formData.has_external_images"
              :items="form.has_external_images.items"
              @update:value="handleHasExternalImagesChange"
            />
            <BaseErrorMessage v-if="errors.has_external_images">
              {{ errors.has_external_images }}
            </BaseErrorMessage>
          </div>
        </div>


        <!-- // checkbox -->

          <!-- requestPerson -->
          <div class="form-request__person">
            <div class="form-request__person-items">
              <BaseCaption :text="form.captions[2].text" tag="h3" />

              <div class="form-request__person-item">
                  <BaseLabel
                  :required="form.fields[3].required"
                  :text="form.fields[3].label"
                  >
                    <BaseInput
                      v-model="formData.name"
                      :name="form.fields[3].name"
                      :type="form.fields[3].type" />
                  </BaseLabel>
                  <BaseErrorMessage v-if="errors.name">
                    {{ errors.name }}
                  </BaseErrorMessage>
              </div>


              <div class="form-request__person-item">
                  <BaseLabel
                  :required="form.fields[4].required"
                  :text="form.fields[4].label"
                  >
                    <BaseInput
                      v-model="formData.surname"
                      :name="form.fields[4].name"
                      :type="form.fields[4].type" />
                  </BaseLabel>
                    <BaseErrorMessage v-if="errors.surname">
                      {{ errors.surname }}
                    </BaseErrorMessage>
              </div>

              <div class="form-request__person-item">
                  <BaseLabel
                  :required="form.fields[5].required"
                  :text="form.fields[5].label"
                  >
                    <BaseInput
                      v-model="formData.patronymic"
                      :name="form.fields[5].name"
                      :type="form.fields[5].type" />
                  </BaseLabel>
                    <BaseErrorMessage v-if="errors.patronymic">
                      {{ errors.patronymic }}
                    </BaseErrorMessage>
              </div>
            </div>
            <div class="form-request__person-items">
              <BaseCaption :text="form.captions[3].text" tag="h3" />
              <no-ssr>
                <div class="data-picker">
                  <test
                    :language="language"
                    format="yyyy-MM-dd"
                  v-model="formData.birth"/>
                                    <div class="data-picker__svg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <defs/>
                      <path d="M462 44h-47.667V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14h-168V30c0-16.542-13.458-30-30-30s-30 13.458-30 30v14.37c-.85-.235-1.741-.37-2.666-.37H83.823c-27.57 0-50 22.43-50 50v170.333c0 5.523 4.478 10 10 10s10-4.477 10-10V147h360.51c5.522 0 10-4.477 10-10s-4.478-10-10-10H53.823V94c0-16.542 13.458-30 30-30h39.844c.925 0 1.816-.136 2.666-.37V76.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64h168v12.5c0 16.542 13.458 30 30 30s30-13.458 30-30V64H462c16.542 0 30 13.458 30 30v379.994c0 9.928-8.077 18.006-18.006 18.006s-18.006-8.078-18.006-18.006v-25.869c0-5.523-4.478-10-10-10H329.667c-5.522 0-10 4.477-10 10s4.478 10 10 10h106.321v15.869c0 6.511 1.648 12.643 4.545 18.006H38c-9.925 0-18-8.075-18-18v-15.875h223.825c5.522 0 10-4.477 10-10s-4.478-10-10-10h-99.916c17.474-15.049 28.57-37.309 28.57-62.125 0-45.215-36.785-82-82-82s-82 36.785-82 82c0 24.816 11.096 47.076 28.57 62.125H10c-5.522 0-10 4.477-10 10V474c0 20.953 17.047 38 38 38h435.994C494.95 512 512 494.951 512 473.994V94c0-27.57-22.43-50-50-50zM166.333 76.5c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zm228 0c0 5.514-4.486 10-10 10s-10-4.486-10-10V30c0-5.514 4.486-10 10-10s10 4.486 10 10v46.5zM28.479 376c0-34.187 27.813-62 62-62s62 27.813 62 62-27.813 62-62 62-62-27.813-62-62z"/>
                      <path d="M468.309 129.93c-1.859-1.86-4.439-2.93-7.069-2.93-2.631 0-5.21 1.07-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.069 5.21 2.93 7.07c1.861 1.86 4.439 2.93 7.07 2.93 2.63 0 5.21-1.07 7.069-2.93 1.86-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07zM298.649 441.05c-1.859-1.86-4.439-2.92-7.069-2.92s-5.21 1.06-7.07 2.92c-1.86 1.87-2.93 4.44-2.93 7.07 0 2.64 1.069 5.21 2.93 7.08 1.86 1.86 4.44 2.92 7.07 2.92s5.21-1.06 7.069-2.92c1.86-1.87 2.931-4.45 2.931-7.08s-1.07-5.2-2.931-7.07zM226.245 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 304c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM132.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM319.578 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM412.912 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM226.245 200c-20.953 0-38 17.047-38 38s17.047 38 38 38 38-17.047 38-38-17.047-38-38-38zm0 56c-9.925 0-18-8.075-18-18s8.075-18 18-18 18 8.075 18 18-8.075 18-18 18zM126.104 351.629c-3.906-3.905-10.236-3.905-14.143 0l-32.566 32.567-11.129-11.129c-3.906-3.905-10.236-3.905-14.143 0-3.905 3.905-3.905 10.237 0 14.143l18.201 18.199c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l39.638-39.638c3.905-3.905 3.905-10.237 0-14.142z"/>
                    </svg>
                  </div>
                </div>
              </no-ssr>
                <BaseErrorMessage v-if="errors.birth">
                  {{ errors.birth }}
                </BaseErrorMessage>
            </div>
          </div>

          <!-- requestPerson two-col-->
          <div class="form-request__person form-request__person_two-col">
          <div class="form-request__person-gender">
            <BaseCaption :text="form.captions[4].text" tag="h3" />
            <BaseRadio
              :value.sync="formData.gender"
              :items="form.gender.items"
            />
            <BaseErrorMessage v-if="errors.gender">
              {{ errors.gender }}
            </BaseErrorMessage>
          </div>
          <div class="form-request__person-parents">
            <div class="form-request__person-parents-items form-request__person-parents-items_modify">
              <BaseCaption :text="form.captions[5].text" tag="h3" />

              <div class="form-request__person-item">
                  <BaseLabel
                    :required="form.fields[6].required"
                    :text="form.fields[6].label">
                    <BaseInput
                      v-model="formData.parent_name"
                      :name="form.fields[6].name"
                      :type="form.fields[6].type" />
                  </BaseLabel>
                    <BaseErrorMessage v-if="errors.parent_name">
                      {{ errors.parent_name }}
                    </BaseErrorMessage>
              </div>

              <div class="form-request__person-item">
                  <BaseLabel
                    :required="form.fields[7].required"
                    :text="form.fields[7].label">
                    <BaseInput
                      v-model="formData.parent_surname"
                      :name="form.fields[7].name"
                      :type="form.fields[7].type" />
                  </BaseLabel>
                    <BaseErrorMessage v-if="errors.parent_surname">
                      {{ errors.parent_surname }}
                    </BaseErrorMessage>
              </div>

              <div class="form-request__person-item">
                  <BaseLabel
                    :required="form.fields[8].required"
                    :text="form.fields[8].label">
                  <BaseInput
                    v-model="formData.parent_patronymic"
                    :name="form.fields[8].name"
                    :type="form.fields[8].type" />
                  </BaseLabel>
                    <BaseErrorMessage v-if="errors.parent_patronymic">
                      {{ errors.parent_patronymic }}
                    </BaseErrorMessage>
              </div>
            </div>
          </div>
        </div>

          <!-- requestPerson Address-->
        <div class="form-request__person form-request__person_address">
          <div class="form-request__person-items">
            <BaseCaption :text="form.captions[6].text" tag="h3" />

            <div class="form-request__person-item">
                <BaseLabel
                  :required="form.fields[9].required"
                  :text="form.fields[9].label">
                <BaseInput
                  v-model="formData.index"
                  :name="form.fields[9].name"
                  :type="form.fields[9].type" />
                </BaseLabel>
                  <BaseErrorMessage v-if="errors.index">
                    {{ errors.index }}
                  </BaseErrorMessage>
            </div>

             <div class="form-request__person-item">
                <BaseLabel
                   :required="form.fields[10].required"
                  :text="form.fields[10].label">
                <BaseInput
                  v-model="formData.country"
                  :name="form.fields[10].name"
                  :type="form.fields[10].type" />
                </BaseLabel>
                  <BaseErrorMessage v-if="errors.country">
                    {{ errors.country }}
                  </BaseErrorMessage>
            </div>

             <div class="form-request__person-item">
                <BaseLabel
                 :required="form.fields[11].required"
                  :text="form.fields[11].label">
                <BaseInput
                  v-model="formData.address"
                  :name="form.fields[11].name"
                  :type="form.fields[11].type" />
                </BaseLabel>
                  <BaseErrorMessage v-if="errors.address">
                    {{ errors.address }}
                  </BaseErrorMessage>
            </div>
          </div>
        </div>

        <!-- requestPerson Numbers-->
        <div class="form-request__person form-request__person_numbers">
          <div class="form-request__person-items">
            <BaseCaption :text="form.captions[7].text" tag="h3" />

            <div class="form-request__person-item">
                <BaseLabel
                  :required="form.fields[12].required"
                  :text="form.fields[12].label">
                <BaseInput
                  v-model="formData.phone"
                  :name="form.fields[12].name"
                  :type="form.fields[12].type" />
                </BaseLabel>
                  <BaseErrorMessage v-if="errors.phone">
                    {{ errors.phone }}
                  </BaseErrorMessage>
            </div>

<!--            <div class="form-request__person-item">-->
<!--                <BaseLabel-->
<!--                 :required="form.fields[13].required"-->
<!--                  :text="form.fields[13].label">-->
<!--                <BaseInput-->
<!--                  v-model="formData.fax"-->
<!--                  :name="form.fields[13].name"-->
<!--                  :type="form.fields[13].type" />-->
<!--                </BaseLabel>-->
<!--                  <BaseErrorMessage v-if="errors.fax">-->
<!--                    {{ errors.fax }}-->
<!--                  </BaseErrorMessage>-->
<!--            </div>-->

            <div class="form-request__person-item">
                <BaseLabel
                  :required="form.fields[13].required"
                  :text="form.fields[13].label">
                <BaseInput
                  v-model="formData.email"
                  :name="form.fields[13].name"
                  :type="form.fields[13].type" />
                </BaseLabel>
                  <BaseErrorMessage v-if="errors.email">
                    {{ errors.email }}
                  </BaseErrorMessage>
            </div>
          </div>
        </div>

        <div class="form-request__btns">
          <BaseBtn
              type="submit"
              class="form-request__btn"
              :customClass="'default'"
              :text="form.submitBtn.text"
            />

            <BaseBtn
              v-if="pdfData"
              class="form-request__btn"
              :customClass="'default'"
              :to="pdfData"
              target="_blank"
              text="Отримати заявку учасника"
            />

            <BaseBtn
              v-if="pdfDataPatent"
              class="form-request__btn"
              :customClass="'default'"
              :to="pdfDataPatent"
              target="_blank"
              text="Отримати диплом учасника"
            />
        </div>

      </form>

    </div>
  </section>
</template>

<script>

  import BaseRadioSingle from "./_UI/BaseRadioSingle.vue";
  import BaseRadio from "./_UI/BaseRadio.vue";

  export default {

    components: {
      BaseRadio,
      BaseRadioSingle

    },

    props: {
      form: {
        type: Object,
        default() {
          return {
            // submitUrl: `http://api.dreamcar.com.dev11.vintagedev.com.ua/v1/request`,
            submitUrl: `/request`,
            submitBtn: {
              text: "сформувати заявку"
            },
            canselBtn: {
              text: "відмова"
            },
            captions: [
              {
                text: "Дата заявки та Назва творчої роботи"
              },
              {
                text: "Концепція автомобіля мрії*"
              },
              {
                text: "ПІБ Учасника"
              },
              {
                text: "Дата народження"
              },
              {
                text: "Стать Учасника"
              },
              {
                text: "Ім'я батька/матері або законного опікуна Учасника"
              },
              {
                text: "Поштова адреса Учасника"
              },
              {
                text: "Номер телефону та адреса електронної пошти"
              },
              {
                text: "Тип роботи"
              },
              {
                text: "Будь ласка, вкажіть, чи містить ваша робота будь-які зображення, що не є результатом вашої власної творчості"
              },
              {
                text: "Будь ласка, вкажіть, чи містить ваша робота будь-які зображення, що не є результатом вашої власної творчості (наприклад, взяті з відкритих джерел у мережі Інтернет)"
              }
            ],
            fields: [
              {
                label: "Дата",
                required: true
              },
              {
                label: "Назва творчої роботи",
                type: 'text',
                name: "label",
                required: true
              },
              {
                label: "Концепція автомобіля мрії",
                required: true
              },
              {
                label: "Ім'я",
                name:"name",
                type: "text",
                required: true
              },
              {
                label: "По-батькові",
                name:"surname",
                type: "text",
                required: true
              },
              {
                label: "Прізвище",
                name:"patronymic",
                type: "text",
                required: true
              },
              {
                label: "Ім'я батька/матері",
                name:"parent_name",
                type: "text",
                required: true
              },
              {
                label: "По батькові батька/матері",
                name:"parent_surname",
                type: "text",
                required: true
              },
              {
                label: "Прізвище батька/матері",
                name:"parent_patronymic",
                type: "text",
                required: true
              },
              {
                label: "Поштовий індекс",
                name:"index",
                type: "text",
                required: false
              },
              {
                label: "Країна",
                name:"country",
                type: "text",
                required: false
              },
              {
                label: "Адреса",
                name:"address",
                type: "text",
                required: true
              },
              {
                label: "Номер телефону",
                name:"phone",
                type: "tel",
                required: true
              },
              // {
              //   label: "Номер факсу",
              //   name:"fax",
              //   type: "tel",
              //   required: false
              // },
              {
                label: "Адреса електронної пошти",
                name:"email",
                type: "email",
                required: false
              }
            ],
            work_type: {
              items: [
                {
                  value: 'handmade',
                  label: "Намальована від руки",
                  name: "work_type",
                  checked: true
                },
                {
                  value: 'graphics',
                  label: "Створена за допомогою комп’ютерної графіки",
                  name: "work_type"
                }
              ]
            },
            has_external_images: {
              items: [
                {
                  value: true,
                  label: "Так",
                  name: "has_external_images",
                },
                {
                  value: false,
                  label: "Ні",
                  name: "has_external_images",
                }
              ]
            },
            gender: {
              items: [
                {
                  value: 1,
                  label: "Чоловіча",
                  name: "gender",
                  checked: true
                },
                {
                  value: 2,
                  label: "Жіноча",
                  name: "gender"
                }
              ]
            },
          }
        }
      }
    },

    computed: {
      postUrl () {
        return this.form.submitUrl
      }
    },

    data: function () {
      return {
        language: {
          language: 'Ukrainian',
          months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
          monthsAbbr: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
          days: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
          yearSuffix: ' рік',
        },
        formData: {
          date: new Date(),
          label: '',
          description: '',
          name: '',
          surname: '',
          patronymic: '',
          gender: 1,
          parent_name: '',
          parent_surname: '',
          parent_patronymic: '',
          birth: new Date(),
          index: '',
          country: '',
          address: '',
          phone: '',
          // fax: '',
          email: '',
          has_external_images: null,
          work_type: 'handmade'
        },
        errors: {
          date: '',
          label: '',
          description: '',
          name: '',
          surname: '',
          patronymic: '',
          gender: '',
          parent_name: '',
          parent_surname: '',
          parent_patronymic: '',
          birth: '',
          index: '',
          country: '',
          address: '',
          phone: '',
          // fax: '',
          email: '',
          work_type: '',
          has_external_images: '',
        },
        pdfData: null,
        pdfDataPatent: null
      }
    },
    methods: {
      handleWorkTypeChange(value) {
        this.formData.work_type = value;
        this.formData.has_external_images = null;
        this.errors.has_external_images = '';
      },

      handleHasExternalImagesChange(value) {
        this.formData.has_external_images = value;
        this.errors.has_external_images = '';
      },
      submit (e) {
        //Created cope of this.formData and format it for BE
        const formatedForm = Object.assign({}, this.formData)
        formatedForm.date = parseInt(formatedForm.date / 1000);
        formatedForm.birth = parseInt(formatedForm.birth / 1000);

        this.post(formatedForm)

      },

      async post (body) {
        for(let i in this.errors) {
          this.errors[i] = ''
        }

        await this.$axios
        .post(this.postUrl, body)
        .catch((e) => {
          for (let i = 0; i < e.response.data.length; i++) {
            const key = e.response.data[i].field;
            const message = e.response.data[i].message;
            this.errors[key] = message
          }
        })
        .then((e) => {
          // window.open(`${this.$store.state.data.API}/render-pdf?token=${e.data}`, '_blank')
          this.pdfData = `${this.$store.state.data.API}/render-pdf?token=${e.data}`
          this.pdfDataPatent = `${this.$store.state.data.API}/render-patent-pdf?token=${e.data}`
        })
      }
    }
  }
</script>

<style lang="scss">
.form-request {
  position: relative;
  padding: 90px 0;

  form {
    @include media-max($tablet-width) {
      padding: 0 15px;
    }
  }

  &__wrapper {
    max-width: 1168px;
    width: 100%;
    margin: 0 auto;

    @include media-max($desktop-width) {
      max-width: 718px;
    }

     @include media-max($tablet-width) {
       max-width: 100%;
     }
  }

  &__btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  &__btn {
    margin: 0 15px 30px;
    text-transform: uppercase;
  }

  &__date {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-bottom: 30px;

    @include media-max($tablet-width) {
      margin-bottom: 15px;
    }

    &-items {
      display: flex;
      flex-wrap: wrap;

      @include media-max($tablet-width) {
        flex-wrap: wrap;
      }
    }

    &-item {
      width: 50%;

      @include media-max($tablet-width) {
        width: 100%;
        margin-bottom: 15px;
      }

      label {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.form-request__concept {
  width: 100%;
  margin-bottom: 30px;

  @include media-max($tablet-width) {
    margin-bottom: 15px;
  }

  &-item {
    width: 100%;

    textarea {
      width: 100%;
      min-height: 100px;
      resize: none;
      color: #1e2a32;
      font-weight: 400;
      border-radius: 4px;
      background-color: #f3f3f3;
      border: none;
      outline: none;
      // cursor: pointer;
      padding-left: 17px;
      padding-top: 20px;
      box-sizing: border-box;
    }
  }
}

.form-request__person {
  margin-bottom: 30px;

  @include media-max($tablet-width) {
    margin-bottom: 15px;
  }

  &-items:first-child {
    margin-bottom: 30px;
  }

  &-item {
    width: 100%;
    margin-bottom: 30px;

    @include media-max($tablet-width) {
      margin-bottom: 10px;
    }

    label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      span {
        flex-grow: 1;
      }

      input {
        max-width: 100%;
        width: 100%;
      }
    }
  }

  &_two-col {
    display: flex;

    @include media-max($tablet-width) {
      flex-wrap: wrap;
    }
  }

  &-parents {
    flex-grow: 1;
  }
}

.vdp-datepicker {
  input {
    padding-left: 15px;
    padding-top: 1px;
    min-height: 30px;
    outline: none;
    font-family: $OpenSans;
    background-color: transparent;
    border-radius: 4px;
    outline: none;
    border: 1px solid rgba(#1e2a32, 0.3);
    cursor: pointer;

    @include media-max($desktop-width) {
      font-size: 14px;
    }

    @include media-max($tablet-width) {
      font-size: 16px;
    }
  }
}

.data-picker {
  position: relative;
  display: inline-flex;

  &__svg {
    position: absolute;
    right: 6px;
    top: 3px;
    z-index: -1;

    svg {
      width: 22px;
      height: 22px;
    }
  }
}

.vdp-datepicker__calendar {
  font-family: $OpenSans !important;
}

.form-request__person-external-images{
  padding-left: 24px;

  .caption{
    margin-bottom: 8px;
  }
  .radio-btn__label:last-of-type{
    margin-bottom: 0;
  }
  .field-error{
    margin-bottom: 8px;
  }
  .radio-btn{
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// components/FormRequest.vue